export default __webpack_public_path__ + "static/media/box-important.59622150.svg";